import React from 'react';
import { Route, Switch } from 'react-router-dom';

import TimbradoSftp from './TimbradoSftp';
import GuardianRoute from '../../shared/GuardianRoute';
import TimbradoSftpInfo from './TimbradoSftpInfo';

const TimbradoSftpRoutes = () => {
  return (
    <Switch>
      <GuardianRoute
        path="/modulos/timbrado-sftp"
        component={TimbradoSftp}
        can="timbrado.sftp.listar.archivos"
        exact
      />
      <Route
        path="/modulos/timbrado-sftp/:id/info"
        component={TimbradoSftpInfo}
        exact
      />
    </Switch>
  );
};

export default TimbradoSftpRoutes;
